import React from 'react';
import './style.css';


export const LoadingModule = () => {
  return (
    <div className="spinner">
      <div className="rect1"></div>
      <div className="rect2"></div>
      <div className="rect3"></div>
      <div className="rect4"></div>
      <div className="rect5"></div>
    </div>
  )
}

const Loading = () => {
  return (
    <div className="center">

      <div className="loadingTitle">
        <div className="">
          <img src="/logo.png" alt="logo.png" style={{ width: 200 }} />
        </div>
      </div>
      <div className="mtlg">
        <LoadingModule />
      </div>
    </div>
  )
}

export default Loading
